import { Product, HycProduct, IgcProduct } from '@/creditflowresearch/domain/Product';
import { EmergingMarket } from '@/creditflowresearch/domain/Market';

interface IParams {
  hasCommentaryAndDealFlow: boolean,
  planProductIds: string[] | undefined,
  productIds: string[],
  markets: string | string[] | undefined,
}

export const hasPlanTopicsAccess = ({
  hasCommentaryAndDealFlow,
  planProductIds,
  productIds,
  markets,
}: IParams): boolean => {
  if (!hasCommentaryAndDealFlow) {
    return false;
  }

  const planProducts = planProductIds || [];

  if (String(markets || '').includes(EmergingMarket.ABBREVIATION)) {
    return planProducts.some((productId) =>
      Product.isOfType(productId, HycProduct.TYPE) || Product.isOfType(productId, IgcProduct.TYPE));
  }

  return productIds.every((productId) => planProducts.includes(productId));
};
